export function SubstantiationPanel({ items }: { items: Array<{ tax_line?: string; attached?: number; missing?: number; attested?: number; note?: string }> }) {
  return (
    <section className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="substantiation-heading">
      <h2 id="substantiation-heading" className="font-semibold">4. Substantiation</h2>
      {items.length === 0 ? <p className="mt-2 text-sm text-muted-foreground">No substantiation gaps reported.</p> : <div className="mt-3 space-y-3 text-sm">{items.map((item) => <div key={item.tax_line}><div className="flex justify-between"><span>Schedule C {item.tax_line}</span><span>Attached {item.attached ?? '—'} · Missing {item.missing ?? '—'} · Attested {item.attested ?? '—'}</span></div><p className="text-xs text-muted-foreground">{item.note ?? 'Missing is different from ineligible.'}</p></div>)}</div>}
    </section>
  );
}

export default SubstantiationPanel;
